import logo from '../../images/logo-removebg-preview.png'

/* This example requires Tailwind CSS v2.0+ */
const navigation = [
    { name: 'Acceuil', href: 'home' },
    { name: 'Nous contacter', href: '/contact' },
    { name: 'Nous soutenir', href: '/donations' },
    { name: 'Galerie', href: '/galerie' },
  ]
  
  export default function Example() {
    return (
      <header className="bg-red-500 fixed z-50 w-full">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Top">
          <div className="w-full py-6 flex items-center justify-between border-b border-red-500 lg:border-none">
            <div className="flex items-center">
              <a href="#">
                <span className="sr-only">Workflow</span>
                <img
                  className="h-10 w-auto"
                  src={logo}
                  alt=""
                />
              </a>
              <div className="hidden ml-10 space-x-8 lg:block">
                {navigation.map((link) => (
                  <a key={link.name} href={link.href} className="text-base font-medium text-white hover:text-red-50">
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
            {/* <div className="ml-10 space-x-4">
              <a
                href="#"
                className="inline-block bg-red-500 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75"
              >
                Sign in
              </a>
              <a
                href="#"
                className="inline-block bg-white py-2 px-4 border border-transparent rounded-md text-base font-medium text-red-600 hover:bg-red-50"
              >
                Sign up
              </a>
            </div> */}
          </div>
          <div className="py-4 flex flex-wrap justify-center space-x-6 lg:hidden">
            {navigation.map((link) => (
              <a key={link.name} href={link.href} className="text-base font-medium text-white hover:text-red-50">
                {link.name}
              </a>
            ))}
          </div>
        </nav>
      </header>
    )
  }
  